import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {headers} from "./headers";
import {AIProviderSettings} from "../../ai/providers/AIProvider";
import {host} from "./api";

export type AccountSettings = 'profile' | 'ai' | 'storage'
export type ProjectSettings = 'general' | 'members' | 'ai' | 'storage'

export interface SettingsState {
    accountSettings: AccountSettings | undefined
    projectSettings: ProjectSettings | undefined
}

const initialState: SettingsState = {
    accountSettings: undefined,
    projectSettings: undefined
}

export const openAccountSettings = createAsyncThunk('openAccountSettings', async (settings: AccountSettings) => {
    return settings
})

export const closeAccountSettings = createAsyncThunk('closeAccountSettings', async () => {
    return undefined
})

export const openProjectSettings = createAsyncThunk('openProjectSettings', async (settings: ProjectSettings) => {
    return settings
})

export const closeProjectSettings = createAsyncThunk('closeProjectSettings', async () => {
    return undefined
})


export const appSettingsSlice = createSlice({
    name: 'appSettings',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(openAccountSettings.fulfilled, (state, action) => {
                state.accountSettings = action.payload
            })
            .addCase(closeAccountSettings.fulfilled, (state, action) => {
                state.accountSettings = action.payload
            })
            .addCase(openProjectSettings.fulfilled, (state, action) => {
                state.projectSettings = action.payload
            })
            .addCase(closeProjectSettings.fulfilled, (state, action) => {
                state.projectSettings = action.payload
            })
    }
})

export default appSettingsSlice.reducer;